<script>
  import { isEnglish, setIsEnglish } from "../stores/cookies.js";
  import BottomCard from "../components/BottomCard.svelte";
  import AppBar from "../components/AppBar.svelte";
  import ServicesCard from "../components/ServicesCard.svelte";
  import ServiceBannerCard from "../components/ServiceBannerCard.svelte";
</script>

<AppBar />

<main class="p-4 mx-auto space-y-6">
  <h1
    class="
    text-center md:text-left
    text-blue-900 font-bold
    text-2xl sm:text-3xl md:text-4xl lg:text-5xl
    tracking-tight
    pl-6 sm:pl-8 md:pl-12 lg:pl-16 xl:pl-24 2xl:pl-32
    pt-0 sm:pt-2 md:pt-4 lg:pt-6 xl:pt-8 2xl:pt-10
  "
  >
    {$isEnglish ? "Services" : "Dienste"}
  </h1>

  <div class="py-8 md:py-12 px-6 sm:px-8 md:px-12 lg:px-16 xl:px-24 2xl:px-32">
    <div
      class="
    grid
    gap-6 md:gap-8 lg:gap-10 xl:gap-12
    grid-cols-[repeat(auto-fit,minmax(max(280px,20%),1fr))]
    justify-items-center
  "
    >
      <ServicesCard
        imageSrc="assets/services/medicine.jpg"
        title={$isEnglish ? "Medical" : "Medies"}
        description={$isEnglish
          ? "Vredenburg Veterinary Animal Hospital offers complete comprehensive medical and surgical care for your pet."
          : "Vredenburg Dierekliniek bied omvattende mediese en chirurgiese sorg aan vir jou troeteldier."}
      />

      <ServicesCard
        imageSrc="assets/services/dental1.jpg"
        title={$isEnglish ? "Dental" : "Tandheelkunde"}
        description={$isEnglish
          ? "Dental consultations and cleaning (prophylaxis) and dental extractions as required."
          : "Tandheelkundige konsultasies en skoonmaak (voorkomende sorg) en tand eksraksies soos benodig."}
      />

      <ServicesCard
        imageSrc="assets/services/surgery1.jpg"
        title={$isEnglish ? "Surgery" : "Chirurgie"}
        description={$isEnglish
          ? "We perform surgery on pets, production animals, equines and exotics."
          : "Ons doen chirurgie op alle troetel, produksie, perde en eksotiese diere."}
      />

      <ServicesCard
        imageSrc="assets/services/vetshop.jpg"
        title={$isEnglish ? "Vet Shop" : "Veearts Winkel"}
        description={$isEnglish
          ? "Prescription and therapeutic diets available (prescription diets with prior doctor consult). We also have toys, leashes and treats."
          : "Voorskrif en terapeutiese dieëte beskikbaar (voorskrif dieëte moet voorafgegaan word met 'n veearts konsultasie). Ons het ook 'n reeks speelgoed, leibande en lekkernye."}
      />

      <ServicesCard
        imageSrc="assets/services/farm2.jpg"
        title={$isEnglish ? "Farm Visits" : "Plaas Besoeke"}
        description={$isEnglish
          ? "We do farm visits to assess herd health, inseminations, ultrasound or assist during emergencies."
          : "Ons besoek plase om kudde gesondheid te assesseer, inseminasies en sonar te doen, en te assisteer gedurende noodgevalle."}
      />

      <ServicesCard
        imageSrc="assets/services/farm1.jpg"
        title={$isEnglish ? "Game Darting" : "Wild Vang"}
        description={$isEnglish
          ? "We love working with large game. We do darting, anastetics and general surgery on site in the bush."
          : "Ons is mal daaroor om met groot wild te werk. Ons doen pyling, narkose en algemene chirurgie op jou plaas in die veld."}
      />

      <ServicesCard
        imageSrc="assets/services/xray1.jpg"
        title={$isEnglish ? "X-Rays" : "X-Strale"}
        description={$isEnglish
          ? "Our diagnostic imaging services include radiography (x-rays) for screening of fractures, musculo-skeletal problems as well as hip and elbow displasia."
          : "Ons skanderings dienste sluit radiografie (x-strale) vir die ondersoek van breuke in, skelet en spier probleme asook heup en elmboog displasie."}
      />

      <ServicesCard
        imageSrc="assets/services/blood1.jpg"
        title={$isEnglish ? "Blood Analysis" : "Bloed Analiese"}
        description={$isEnglish
          ? "We do blood analysis either on site or if need be, have it sent away for analysis. We have our in-house Idexx blood machines that can provide results within minutes."
          : "Ons doen of bloed analiese self by die praktyk as benodig, of ons kan dit wegstuur vir verdere analiese. Ons het ons binneshuise  Idexx bloedmasjiene wat binne minute resultate kan lewer."}
      />
    </div>
  </div>

  <div class="w-full h-[2px] bg-blue-600 my-10"></div>

  <h1
    class="
    text-center md:text-left
    text-blue-900 font-bold
    text-2xl sm:text-3xl md:text-4xl lg:text-5xl
    tracking-tight
    pl-6 sm:pl-8 md:pl-12 lg:pl-16 xl:pl-24 2xl:pl-32
    pt-0 sm:pt-2 md:pt-4 lg:pt-6 xl:pt-8 2xl:pt-10
  "
  >
    {$isEnglish ? "Categories" : "Kategorieë"}
  </h1>

  <div
    id="0"
    class="py-8 md:py-12 px-6 sm:px-8 md:px-12 lg:px-16 xl:px-24 2xl:px-32"
  >
    <ServiceBannerCard
      title={$isEnglish ? "Small Animals" : "Klein Diere"}
      description={$isEnglish
        ? "We treat cats and dogs of all sizes, shapes and personalities. We are equipped with superb diagnostic capabilities, laboratory testing, profound veterinary surgery skills, emergency pet care, and an in-house pharmacy. We can diagnose, treat, and even help prevent a variety of problematic pet conditions."
        : "Ons behandel katte en honde van verskillende groottes, rasse en persoonlikhede. Ons is ten volle toegerus met al die nodige toerusting om diagnosis te maak, insluitende laboratoruim toetse. Ons het uitstekende veeartseny chirugiese vaardighede binne die praktyk, insluitende troeteldier noodgeval behandeling."}
      leftBullets={$isEnglish
        ? [
            "•  Vaccinations",
            "•  Surgical Procedures",
            "    •  Fractures",
            "    •  Sterilization",
            "    •  Dental Scaling & Polishing",
            "    •  Anal Gland Removal",
            "    •  Bite Wounds",
            "    •  Ear Flushing",
            "•  Parasite Control",
            "•  De-Worming",
          ]
        : [
            "•  Inentings",
            "•  Chirurgiese Prosedures",
            "    •  Frakture",
            "    •  Sterilisasie",
            "    •  Tande Skoonmaak & Polering",
            "    •  Anale Kliere Verwydering",
            "    •  Byt Wonde",
            "    •  Ore Uitspuit",
            "•  Parasiet Beheer",
            "•  Ontwurming",
          ]}
      rightBullets={$isEnglish
        ? [
            "•  Ultrasound",
            "•  Skin Care",
            "    •  Allergy Treatments",
            "    •  Growth Removals",
            "    •  Tattooing",
            "    •  Hair Loss & Other",
            "•  X-Rays",
            "•  Microchipping",
            "•  Annual Health check-ups",
          ]
        : [
            "•  Sonar",
            "•  Vel Behandeling",
            "    •  Allergie Beheer",
            "    •  Verwydering van Vergroeisels",
            "    •  Tattoeëring",
            "    •  Haar Verlies & Ander",
            "•  X-Strale",
            "•  Microchipping",
            "•  Jaarlikse Gesondheids ondersoeke",
          ]}
      imageSrc="assets/animals/small1.jpg"
      alt="Service Banner Card"
    />
  </div>

  <div
    id="1"
    class="py-8 md:py-12 px-6 sm:px-8 md:px-12 lg:px-16 xl:px-24 2xl:px-32"
  >
    <ServiceBannerCard
      title={$isEnglish ? "Production Animals" : "Produksie Diere"}
      description={$isEnglish
        ? "Our aim is to work with you to improve animal health and welfare including the productivity and profitability of your business. We offer a 24 hour farm animal veterinary service, with wide expertise in disease prevention and control as well as a thorough and caring approach to individual animal medicine.\n\nServices for cattle and sheep include herd visits for dairy and beef cattle as well as sheep, with pregnancy diagnosis (by hand or sonar) as well as advice on breeding and fertility of female animals - bull and ram testing is also available.\n\nWe also offer advice on vaccinations, dipping and dosing. Reproductive procedures e.g. calvings, caesarians and prolapses as well as basic operations e.g. rumenotomies are available. A variety of blood tests can be performed in-house, the rest are sent away."
        : "Ons streef daarna om saam met jou te werk om diere gesondheid en welstand te verbeter, asook die produktiwiteit en winslyn van jou besigheid. Ons bied 24 uur plaas veeartseny dienste aan, met 'n wye verskeidenheid kennis in die voorkoming en beheer van siektes asook 'n deuglike benadring tot sorg vir individuele diere.\n\nDienste vir beeste en skape sluit kudde besoeke vir melk en vleis beeste in, asook vir skape. Ons doen ook dragtigheids ondersoeke (met sonar of met die hand) insluitende advies met betrekking tot die teling en vrugbaarheid van vroulike diere - en bul- en ram toetse. Die toetse sluit geslagsorgaan gesondheid en reproduksie siektesin.\n\nOns bied ook raad aan oor inentings, hoe om diere te dip en dosering. Reproduksie gevalle b.v. geboortes, keisersnitte en prolapse insluitende meer basiese gevalle b.v. maag ondersoeke is alles beskikbaar. 'n Wye verskeidenheid bloed toetse kan ook gedoen word by die praktyd, of na patoloë weggestuur word vir verdere ondersoek."}
      leftBullets={$isEnglish
        ? [
            "•  Inocculation programmes",
            "•  Bull and Ram Testing",
            "•  Pregnancy Testing",
            "•  Post Mortems",
          ]
        : [
            "•  Entingsprogramme",
            "•  Bultoetse en Ramtoetse",
            "•  Dragtigheidsondersoeke",
            "•  Na-doodse ondersoeke",
          ]}
      rightBullets={$isEnglish
        ? [
            "•  Ultrasound",
            "•  General Health & Herd Health",
            "•  Diseases",
            "•  Dystocia",
          ]
        : [
            "•  Ultraklank",
            "•  Algemene Gesondheid & Kudde Gesondheid",
            "•  Siektes",
            "•  Dystokie",
          ]}
      imageSrc="assets/animals/production3.jpg"
      alt="Service Banner Card"
    />
  </div>

  <div
    id="2"
    class="py-8 md:py-12 px-6 sm:px-8 md:px-12 lg:px-16 xl:px-24 2xl:px-32"
  >
    <ServiceBannerCard
      title={$isEnglish ? "Wildlife" : "Wild"}
      description={$isEnglish
        ? "We assist and advise with breeding projects for wildlife. We specialise in darting, capture and immobilising game and can also help in planning game capture operations."
        : "Ons help graag met advies oor teel projekte vir wild. Ons spesialiseer in die pyl, vang en immobilisering van wild en help ook graag met die beplanning van wild vang operasies."}
      leftBullets={$isEnglish
        ? ["•  Darting", "•  Capture", "•  Care", "•  Management"]
        : ["•  Dyling", "•  Vang", "•  Versorg", "•  Bestuur"]}
      imageSrc="assets/animals/wildlife1.jpg"
      alt="Service Banner Card"
    />
  </div>

  <div
    id="3"
    class="py-8 md:py-12 px-6 sm:px-8 md:px-12 lg:px-16 xl:px-24 2xl:px-32"
  >
    <ServiceBannerCard
      title={$isEnglish ? "Equines" : "Perde"}
      description={$isEnglish
        ? "Weskus Veeartseny aims to offer professional, efficient and compassionate service to our clients and their horses.\n\nWe have a mobile ultrasound unit which can provide an ultrasound services to all our Equine patients.\n\nAnnual dental checkups are necessary to ensure that your horse’s teeth are kept in a healthy condition. We work closely with Dental Technicians to provide the best care possible."
        : "Weskus Veeartseny streef om profesionele, effektiewe dienste met deernis aan ons kliente en hul perde te bied.\n\nOns het a mobiele sonar eenheid waarmee ons al ons sonar dienste aan ons perde kliente bied.\n\nJaarlikse tande ondersoeke is noodsaaklik om te verseker dat jou perd se tande in 'n gesonde kondisie bly. Ons werk nou saam met Tandheelkundiges om die beste sorg te bied."}
      leftBullets={$isEnglish
        ? [
            "•  Laminitis",
            "•  Colic",
            "•  Equine Surgery",
            "•  Heaves",
            "•  Dental Care",
            "•  Pregnant Mares",
            "    •  Foaling",
            "    •  Foal Births",
          ]
        : [
            "•  Laminitis",
            "•  Koliek",
            "•  Chirurgie",
            "•  Heaves",
            "•  Tandheelkundige Versorging",
            "•  Dragtige Merries",
            "    •  Bevallings",
            "    •  Vulletjie Gesondheid",
          ]}
      imageSrc="assets/animals/horse2.jpg"
      alt="Service Banner Card"
    />
  </div>

  <div
    id="4"
    class="py-8 md:py-12 px-6 sm:px-8 md:px-12 lg:px-16 xl:px-24 2xl:px-32"
  >
    <ServiceBannerCard
      title={$isEnglish ? "Exotics" : "Eksotiese Diere"}
      leftBullets={$isEnglish
        ? [
            "•  Bird Wing, Beak & Nail Trimming",
            "•  Nutrition & Feeding Advice",
            "•  Exotic Animal Surgery",
            "•  Alpacas & Llamas",
          ]
        : [
            "•  Voël Vlerk, Bek & Nael Knip",
            "•  Voer & Voedsaamheids Advies",
            "•  Eksotiese Diere Chirurgie",
            "•  Alpacas & Llamas",
          ]}
      imageSrc="assets/animals/exotic_pet3.jpg"
      alt="Service Banner Card"
    />
  </div>

  <BottomCard />
</main>
